import React, { useState, useEffect } from "react";
import { Breadcrumb, Image } from "antd";
import { CloseOutlined, DoubleRightOutlined } from "@ant-design/icons";
import Navbar from "../../components/Navbar/Navbar";
import { routes } from "../../Routes";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import UploadBillImage from "./uploadBillImage";
import { UserImageUpload } from "../../API  Functions/UserMangement";
import { updatePOImages } from "../../API  Functions/PurchaseFunctions";
import UsermanagementPopup from "../../Popups/usermanagementPopup";
import LoadingSpinner from "../../components/Loading";
import i18next from "i18next";
import { checkPermission } from "../../Utils/permissionHelper";
import JsBarcode from "jsbarcode";
import labelSample from "../../assets/35mm.png";

const PurchaseOrder = () => {
  const { t } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const [noOrdersFound, setNoOrdersFound] = useState(false);
  const location = useLocation();
  const { orderData, from } = location.state || {};
  const data = orderData;

  console.log("from---->", from);

  // State to store base64 image data
  const [base64Images, setBase64Images] = useState([]);
  const [addImage, setAddImage] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  const [popup, setpopup] = useState(false);
  const [message, setmessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(false);
  const [isFileValid, setFileValid] = useState(true);
  const isGinne = useSelector(
    (state) => state?.geneLoginReducer?.isGinneLogin
  );

  // --- Label printing state ---
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [showPriceModal, setShowPriceModal] = useState(false);
  const [isPrintMode, setIsPrintMode] = useState(false);

  useEffect(() => {
    if (base64Images && isFileValid === false) {
      setBase64Images("");
    }
  }, [isFileValid, base64Images]);

  useEffect(() => {
    if (data?.order_details?.attached_image_urls?.length > 0) {
      setAddImage(true);
    }
  }, [data]);

  // --- Label printing helpers (same logic as InventoryTableComponent) ---
  const generateBarcodeSVG = (value) => {
    const svg = document.createElement("svg");
    JsBarcode(svg, value, {
      format: "CODE128",
      lineColor: "#000",
      height: 60,
      displayValue: true,
      fontSize: 20,
      margin: 0,
    });
    return svg.outerHTML;
  };

  const handlePrintLabels = (isPrice) => {
    const labels = selectedProducts
      .map((item) => {
        const barcodeSVG = generateBarcodeSVG(item.barcode);
        return `
        <div class="label">
          <div class="product-name">${item.name}</div>
          ${barcodeSVG}
          ${
            isPrice
              ? `<div class="price">EGP ${item.price ? item.price.toFixed(2) : "0.00"}</div>`
              : ""
          }
        </div>
      `;
      })
      .join("");

    const htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8" />
      <title>Print Labels</title>
      <style>
        @page {
          size: 35mm 24mm;
          margin: 0;
        }
        body {
          padding: 0;
          font-family: Arial, sans-serif;
          margin: 0 auto;
        }
        .label {
          width: 35mm;
          height: 24mm;
          margin: 0 auto;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          text-align: center;
          padding: 1mm 1mm 1mm 2mm;
        }
        .label svg {
          width: 33mm;
          height: 10mm;
          display: block;
        }
        .product-name {
          font-size: 2.7mm;
          max-height: 9mm;
          overflow: hidden;
          margin-top: auto;
          margin-bottom: 3px;
        }
        .price {
          font-size: 3mm;
          margin-top: 3px;
        }
      </style>
    </head>
    <body>
      ${labels}
    </body>
    </html>
  `;

    const printWindow = window.open("", "_blank");
    printWindow.document.write(htmlContent);
    printWindow.document.close();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 300);
  };

  const toggleSelectProduct = (product) => {
    setSelectedProducts((prev) => {
      const exists = prev.find((p) => p.barcode === product.barcode);
      if (exists) {
        return prev.filter((p) => p.barcode !== product.barcode);
      }
      return [...prev, product];
    });
  };

  const handleExitPrintMode = () => {
    setIsPrintMode(false);
    setSelectedProducts([]);
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      const allProducts = data.lines.map((product) => ({
        barcode: product.barcode,
        name: product.product_name,
        price: product.sale_price,
      }));
      setSelectedProducts(allProducts);
    } else {
      setSelectedProducts([]);
    }
  };

  const handleAttachImages = async () => {
    if (!checkPermission("/purchase/list", isGinne)) {
      return;
    }

    setProcessing(true);
    if (base64Images.length > 0) {
      try {
        const uploadedUrls = [];

        const existingImagesCount =
          data?.order_details?.attached_image_urls?.length || 0;

        for (let i = 0; i < base64Images.length; i++) {
          const imageName = `${data?.order_details.order_id}-${String(
            existingImagesCount + i + 1
          ).padStart(2, "0")}`;

          const imageResponse = await UserImageUpload(
            base64Images[i],
            imageName
          );

          if (imageResponse) {
            console.log(`Image ${i + 1} uploaded successfully`);
            uploadedUrls.push(imageResponse);
          } else {
            console.error(`Error uploading image ${i + 1}:`, imageResponse);
          }
        }

        if (uploadedUrls.length > 0) {
          setImageUrls(uploadedUrls);
          const poId = data?.order_details?.order_id;

          const payload = {
            po_id: poId,
            image_urls: uploadedUrls,
          };
          const UploadRes = await updatePOImages(payload);
          if (UploadRes?.result?.status_code === 200) {
            console.log("updated successfully", UploadRes);
            setmessage("Image Uploaded Successfully");
            setProcessing(false);
            setIsSuccess(true);
            setpopup(true);
          } else {
            console.error("Error uploading image", UploadRes);
            setProcessing(false);
          }
        }

        setBase64Images([]);
      } catch (error) {
        console.error("Error during image upload:", error);
        setProcessing(false);
      }
    } else {
      console.log("No images to upload");
      setProcessing(false);
    }
  };

  const handleCancel = () => {
    setBase64Images([]);
  };

  const handleRemoveImage = (index) => {
    setBase64Images((prev) => prev.filter((_, i) => i !== index));
  };

  const handleClose = () => {
    setpopup(false);
    setIsSuccess(false);
    navigate(routes.purchase.purchaseList);
  };

  const allSelected =
    data?.lines?.length > 0 &&
    data.lines.every((product) =>
      selectedProducts.some((p) => p.barcode === product.barcode)
    );

  return (
    <>
      {processing && <LoadingSpinner />}

      {/* Print Price Modal */}
      {showPriceModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl p-8 w-[500px] shadow-2xl text-center relative">
            <button
              className="absolute top-3 right-3 text-gray-600 hover:text-black text-2xl"
              onClick={() => setShowPriceModal(false)}
            >
              ×
            </button>
            <div className="flex justify-center mb-5">
              <img
                src={labelSample}
                alt="Label size example"
                className="w-72 rounded-lg border"
              />
            </div>
            <p className="text-base text-gray-700 mb-4">
              {t("Your labels are sized 35mm × 24mm as shown above.")}
            </p>
            <h2 className="text-xl font-semibold mb-6">
              {t("Do you want to print product price also?")}
            </h2>
            <div className="flex justify-between mt-4">
              <button
                className="px-6 py-3 bg-gray-300 rounded-lg w-32 text-lg font-medium"
                onClick={() => {
                  setShowPriceModal(false);
                  handlePrintLabels(false);
                  handleExitPrintMode();
                }}
              >
                {t("No")}
              </button>
              <button
                className="px-6 py-3 bg-primaryBlue text-white rounded-lg w-32 text-lg font-medium"
                onClick={() => {
                  setShowPriceModal(false);
                  handlePrintLabels(true);
                  handleExitPrintMode();
                }}
              >
                {t("Yes")}
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="flex">
        <div className="flex flex-col bg-[#F6F7F9] min-h-[93vh] min-w-[100vh] flex-1">
          <Navbar heading="Purchase History" />
          <div className="me-4 ms-3 font-extrabold">
            <Breadcrumb
              separator={<DoubleRightOutlined />}
              items={[
                {
                  title: (
                    <Link
                      to={
                        from === "vendor_payment"
                          ? routes.purchase.supplyPayment
                          : routes.purchase.purchaseList
                      }
                    >
                      {from === "vendor_payment"
                        ? t("Vendor Payment")
                        : t("Purchase History")}
                    </Link>
                  ),
                  key: "purchaseOrder",
                },
                { title: `${data?.order_details?.order_no}` },
              ]}
              className="relative mt-3"
            />

            {/* Display attached images section */}
            <h3 className="text-l mt-2 font-semibold text-[#272728]">
              {t("Attached Bill Images")}
            </h3>
            <div className="mt-2 min-w-full overflow-hidden border-[#C6C6C6] border-2 border-dashed bg-white rounded-lg">
              <div className="ms-2 me-2">
                {data?.order_details?.attached_image_urls?.length > 0 ? (
                  <div className="mt-4 pb-2 min-w-full">
                    <div className="flex space-x-4 overflow-x-auto scrollbar-thin overflow-hidden">
                      {data?.order_details?.attached_image_urls.map(
                        (image, index) => (
                          <div
                            key={index}
                            className="flex-none w-[120px] h-[120px] rounded-lg shadow-md overflow-hidden"
                          >
                            <Image
                              src={image}
                              alt={`Bill${index + 1}`}
                              className="w-full h-full object-cover"
                            />
                          </div>
                        )
                      )}
                    </div>
                  </div>
                ) : (
                  <p className="mt-4 text-center text-gray-600">
                    {t("No Bill Images Attached")}
                  </p>
                )}

                <div className="mt-4">
                  <UploadBillImage
                    foldername={"store_app_UAT"}
                    onfileAdd={`storeuserurl`}
                    setBase64Images={(images) => {
                      setBase64Images((prev) => [...prev, images]);
                    }}
                    imageurl={addImage}
                    setFileValid={setFileValid}
                  />
                </div>
                <div className="flex flex-row justify-center font-medium mt-1 mb-4">
                  <span className="text-center text-xs text-[#999999]">
                    png, jpg, jpeg
                  </span>
                  <span className="ms-1 text-center text-xs text-[#999999]">
                    (max 5mb)
                  </span>
                </div>

                {base64Images.length > 0 && (
                  <>
                    <div className="mt-4">
                      <h4 className="font-normal mb-2 italic text-gray-600">
                        {t("Selected Images")}
                      </h4>
                      <div className="flex space-x-4 overflow-x-auto">
                        {base64Images.map((image, index) => (
                          <div
                            key={index}
                            className="relative flex-none w-[120px] h-[120px] rounded-lg shadow-md overflow-hidden"
                          >
                            <Image
                              src={image}
                              alt={`Uploaded Image ${index + 1}`}
                              className="w-full h-full object-cover"
                            />
                            <button
                              onClick={() => handleRemoveImage(index)}
                              className="absolute top-0 right-0 text-black p-0 rounded-full"
                              style={{ zIndex: 10 }}
                            >
                              <CloseOutlined />
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="mt-4 flex mb-4 gap-2 justify-end">
                      <button
                        onClick={handleCancel}
                        className="px-4 py-2 bg-white text-primaryBlue border border-primaryBlue rounded-lg hover:bg-red-600"
                      >
                        {t("Cancel")}
                      </button>
                      <button
                        onClick={handleAttachImages}
                        disabled={processing}
                        className="px-4 py-2 bg-primaryBlue text-white rounded-lg hover:bg-primaryBlue"
                      >
                        {t("Save")}
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Table header row: title + Print Labels button */}
            <div className="flex items-center justify-between mt-6 mb-2">
              <h3 className="text-sm font-semibold text-[#272728]">
                {t("Order Items")}
              </h3>

              {!isPrintMode ? (
                // Always-visible Print Labels entry point
                <button
                  onClick={() => setIsPrintMode(true)}
                  className="flex items-center gap-1.5 px-3 h-8 bg-[#7EC242] text-white text-sm font-semibold rounded-lg"
                >
                  🖨 {t("Print Labels")}
                </button>
              ) : (
                // Selection mode action bar
                <div className="flex items-center gap-2">
                  <span className="text-sm text-gray-500 italic">
                    {selectedProducts.length > 0
                      ? `${selectedProducts.length} ${t("product(s) selected")}`
                      : t("Select products to print")}
                  </span>
                  <button
                    onClick={handleExitPrintMode}
                    className="px-3 h-8 bg-white border border-gray-300 text-gray-600 text-sm font-medium rounded-lg"
                  >
                    {t("Cancel")}
                  </button>
                  <button
                    disabled={selectedProducts.length === 0}
                    onClick={() => setShowPriceModal(true)}
                    className={`flex items-center gap-1.5 px-3 h-8 text-white text-sm font-semibold rounded-lg transition-opacity ${
                      selectedProducts.length === 0
                        ? "bg-[#7EC242] opacity-40 cursor-not-allowed"
                        : "bg-[#7EC242]"
                    }`}
                  >
                    🖨 {t("Print Selected")}
                    {selectedProducts.length > 0 && (
                      <span className="bg-white text-[#7EC242] text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                        {selectedProducts.length}
                      </span>
                    )}
                  </button>
                </div>
              )}
            </div>

            {/* Selection mode hint banner */}
            {isPrintMode && (
              <div className="mb-3 px-4 py-2 bg-[#f0fbe6] border border-[#7EC242] rounded-lg text-sm text-[#4a7c1f] flex items-center gap-2">
                <span>✅</span>
                <span>{t("Check the products you want to print labels for, then click Print Selected.")}</span>
              </div>
            )}

            {/* Purchase Order Table */}
            <div className="mb-6">
              <table className="min-w-full bg-white rounded-lg border-collapse">
                <thead className="bg-[#D1F1FC] rounded-lg">
                  <tr>
                    {/* Checkbox column — only visible in print mode */}
                    {isPrintMode && (
                      <th
                        className={`py-3 px-4 text-start text-sm font-semibold text-[#272728] ${
                          i18next.language === "ar"
                            ? "rounded-tr-lg"
                            : "rounded-tl-lg"
                        }`}
                      >
                        <input
                          type="checkbox"
                          checked={allSelected}
                          onChange={(e) => handleSelectAll(e.target.checked)}
                        />
                      </th>
                    )}
                    <th
                      className={`py-3 px-4 text-start text-sm font-semibold text-[#272728] ${
                        !isPrintMode
                          ? i18next.language === "ar"
                            ? "rounded-tr-lg"
                            : "rounded-tl-lg"
                          : ""
                      }`}
                    >
                      {t("Product Name")}
                    </th>
                    <th className="py-3 px-4 text-start text-sm font-semibold text-[#272728]">
                      {t("UOM")}
                    </th>
                    <th className="py-3 px-4 text-start text-sm font-semibold text-[#272728]">
                      {t("Quantity")}
                    </th>
                    <th className="py-3 px-4 text-start text-sm font-semibold text-[#272728]">
                      {t("Cost Price")}
                    </th>
                    <th className="py-3 px-4 text-start text-sm font-semibold text-[#272728]">
                      {t("Sales Price")}
                    </th>
                    <th
                      className={`py-3 px-4 text-start text-sm font-semibold text-[#272728] ${
                        i18next.language === "ar"
                          ? "rounded-tl-lg"
                          : "rounded-tr-lg"
                      }`}
                    >
                      {t("Total")}
                    </th>
                  </tr>
                </thead>
                <tbody className="rounded-b-lg">
                  {data.lines.map((product, index) => {
                    const isSelected = selectedProducts.some(
                      (p) => p.barcode === product.barcode
                    );
                    return (
                      <tr
                        key={index}
                        className={`border-t transition-colors ${
                          isPrintMode && isSelected
                            ? "bg-[#f0fbe6]"
                            : index % 2 === 0
                            ? "bg-white"
                            : "bg-[#f9f9f9]"
                        } ${isPrintMode ? "cursor-pointer hover:bg-[#f0fbe6]" : ""}`}
                        onClick={() => {
                          if (isPrintMode)
                            toggleSelectProduct({
                              barcode: product.barcode,
                              name: product.product_name,
                              price: product.sale_price,
                            });
                        }}
                      >
                        {/* Checkbox — only visible in print mode */}
                        {isPrintMode && (
                          <td className="py-3 px-4">
                            <input
                              type="checkbox"
                              checked={isSelected}
                              onChange={() =>
                                toggleSelectProduct({
                                  barcode: product.barcode,
                                  name: product.product_name,
                                  price: product.sale_price,
                                })
                              }
                              onClick={(e) => e.stopPropagation()}
                            />
                          </td>
                        )}

                        {/* Product Name */}
                        <td
                          className={`py-3 px-4 font-normal text-sm text-[#272728] flex items-center ${
                            i18next.language === "ar"
                              ? "rounded-r-lg"
                              : "rounded-l-lg"
                          }`}
                        >
                          <img
                            className="w-12 h-12 object-contain me-3"
                            src={product.image}
                            alt={product.product_name}
                          />
                          {product.product_name}
                        </td>

                        {/* UOM */}
                        <td className="py-3 px-4 font-normal text-sm text-[#272728]">
                          {product.product_uom || "N/A"}
                        </td>

                        {/* Quantity */}
                        <td className="py-3 px-4 font-normal text-sm text-[#272728]">
                          {product.product_qty || "N/A"}
                        </td>

                        {/* Cost Price */}
                        <td className="py-3 px-4 font-normal text-sm text-[#272728]">
                          EGP {product.cost_price?.toFixed(2) || "0.00"}
                        </td>

                        {/* Sales Price */}
                        <td className="py-3 px-4 font-normal text-sm text-[#272728]">
                          EGP {product.sale_price?.toFixed(2) || "0.00"}
                        </td>

                        {/* Total */}
                        <td
                          className={`py-3 px-4 font-normal text-sm text-[#272728] ${
                            i18next.language === "ar"
                              ? "rounded-l-lg"
                              : "rounded-r-lg"
                          }`}
                        >
                          EGP {product.sub_total?.toFixed(2) || "0.00"}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {popup && (
          <UsermanagementPopup
            isSuccess={isSuccess}
            message={message}
            close={() => {
              handleClose();
              if (message === t("User Updated Successfully"));
            }}
          />
        )}
      </div>
    </>
  );
};

export default PurchaseOrder;